import React from "react";

import ReactLogo from "./img/react.png";
import MongoDBLogo from "./img/mongodb.png";
import NodeJSLogo from "./img/nodejs.png";
import JavaLogo from "./img/java.png";
import HtmlLogo from "./img/html.png";
import CssLogo from "./img/css.png";
import JSLogo from "./img/javascript.png";
import PhpLogo from "./img/php.png";
import SQLLogo from "./img/sql.png";

export default function Technologies() {
  return (
    <div class="education group">
      <h2
        class="text-center"
        data-aos="fade-up"
        data-aos-delay="300"
        data-aos-duration="400"
      >
        Programming Languages and Frameworks
      </h2>
      <center>
        <div className="row">
          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={ReactLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              React
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={MongoDBLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              MongoDB
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={NodeJSLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              NodeJS
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={JavaLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Java
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={HtmlLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              HTML
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={CssLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              CSS
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={JSLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Javascript
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={PhpLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              PHP
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={SQLLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              SQL
            </p>
          </div>
        </div>
      </center>
    </div>
  );
}
